import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { UIRouter }                 from '@uirouter/core';

import { ApiService }                  from '../api/api.service';
import { AzureSsoService }             from '../azure-sso/azure-sso.service';
import { BusinessIntelligenceService } from '../business-intelligence/business-intelligence.service';
import { CodeTypeModel }               from '../core/models/code-type';
import { CompanyService }              from '../companies/company.service';
import { ConfirmService }              from '../messages/confirm/confirm.service';
import { GroupModel }                  from '../core/models/group';
import { MessagesService }             from '../messages/messages.service';
import { SessionService }              from '../sessions/session.service';
import { TranslateService }            from '@ngx-translate/core';
import { UserModel }                   from './models/user';

@Component({
  selector   : 'wor-user',
  template: require('./user.component.html')
})
export class UserComponent implements OnInit {
  @Input() user     : UserModel;
  @Input() userQuote: any;

  capricornUser    : any;
  groups           : Array<GroupModel> = [];
  loading          = false;
  originalBiStatus : boolean;
  statusTypes      : Array<CodeTypeModel> = [];

  constructor (
    private apiService                 : ApiService,
    private azureSsoService            : AzureSsoService,
    private businessIntelligenceService: BusinessIntelligenceService,
    public  companyService             : CompanyService,
    private confirmService             : ConfirmService,
    private messagesService            : MessagesService,
    private router                     : UIRouter,
    private sessionService             : SessionService,
    private translateService           : TranslateService
  ) {}

  ngOnInit (): void {
    if (!this.user.id) {
      this.user = {
        dashboard_privileges: 'L',
        state               : 'ACTIVE'
      };
    }

    this.user.confirm_password = this.user.password;
    this.capricornUser         = this.sessionService.base().capricorn_user;
    this.originalBiStatus      = this.user.business_intelligence_user;

    this.apiService.get('/groups', ['*', '*'])
    .then(( groups: Array<GroupModel> ) => {
      this.groups = groups;
    });

    this.apiService.get('/system/user_state_types')
    .then(( types: Array<CodeTypeModel> ) => {
      this.statusTypes = types;
    });
  }

  get isDashboardFull (): boolean {
    return this.user.dashboard_privileges === 'F';
  }

  set isDashboardFull ( val: boolean ) {
    this.user.dashboard_privileges = val ? 'F' : 'L';
  }

  canResetTwoFactorAuth (): boolean {


    return !!this.user.id && this.companyService.isTwoFactorAuthEnabled();


  }

  delete ( form: NgForm ): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.DELETE_USER'))
    .then(() => this.apiService.delete('/user', this.user.id))
    .then(() => {
      form.form.markAsPristine();

      this.router.stateService.go('app.users');

      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.DELETED.USER'), 'success');
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  isBusinessIntelligenceAvailable (): boolean {


    return this.businessIntelligenceService.isAvailable();


  }

  reconnectToAzure (): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.RECONNECT_TO_AZURE'))
    .then(() => this.azureSsoService.reconnectUser(this.user))
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  resetTwoFactorAuth ( form: NgForm ): void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.RESET_TFA'))
    .then(() => this.apiService.post('/user/reset_two_factor_auth_validity', { id: this.user.id }))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.TFA_RESET'), 'success');

      form.form.markAsPristine();

      this.router.stateService.reload();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    });
  }

  save ( form: NgForm ): void {
    this.loading = true;

    const method = this.user.id ? 'patch' : 'post';
    const url    = this.user.id ? '/user'  : '/users';

    this.apiService[method](url, this.user, 'user')
    .then(( user: UserModel ) => {
      this.user.id = user.id;

      return this.originalBiStatus !== this.user.business_intelligence_user
        ? this.businessIntelligenceService.updateStatus(this.user)
        : Promise.resolve(this.user);
    })
    .then(( user: UserModel ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.USER'), 'success');

      form.form.markAsPristine();

      this.router.stateService.go('app.user', { id: user.id }, { reload: true });
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.loading = false;
    });
  }
}
